import { Component, OnInit } from '@angular/core';
import { BusinessUnitsService } from '#services/api';
import { AuthService } from '#services/shared';
import { LoggedUser } from '#models/logged-user';
import { Utility } from '#services/shared/utility';
import { BusinessUnit } from 'models';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
  businessUnits: Array<BusinessUnit>;
  selectedBusinessUnit: BusinessUnit = new BusinessUnit();
  currentUser: LoggedUser;

  messages: Array<any> = [];
  localBUId: number;

  constructor(
    private authService: AuthService,
    private businesUnitSvc: BusinessUnitsService,
  ) {}

  async ngOnInit() {

    this.currentUser = this.authService.getCurrentUser();
    this.getFilter();
    await this.loadBusinessUnits();
    this.setFilter();
    window.scrollTo(0, 0);

  }

  getFilter() {
    const localFilter = localStorage.getItem('localBUFilter');
    if (Utility.isValidString(localFilter)) {
      this.localBUId = +localFilter;
    }
  }

  setFilter() {
    localStorage.removeItem('localBUFilter');
    localStorage.setItem('localBUFilter', this.localBUId.toString());
  }

  async loadItems() {
    this.localBUId = this.selectedBusinessUnit.Id;
    this.setFilter();
  }

  /**
   * Gets the list of business units
   */
  async loadBusinessUnits() {
    await this.businesUnitSvc
      .getUserBUs()
      .toPromise()
      .then(
        (data: BusinessUnit[]) => {
          this.businessUnits = data;
          const allBU = new BusinessUnit();
          allBU.Id = -1;
          allBU.Name = 'All';
          this.businessUnits.unshift(allBU);
          if (Utility.isValidObj(this.localBUId)) {
            this.selectedBusinessUnit = this.businessUnits.find(
              (x) => x.Id === this.localBUId
            );
          } else {
            this.selectedBusinessUnit = this.businessUnits[0];
            this.localBUId = this.selectedBusinessUnit.Id;
          }
        },
        (error) => {
          this.messages = [];
          this.messages.push({
            severity: 'error',
            summary: 'Unable to get Business Units',
            detail: error.error.ExceptionMessage, closable: true,
            sticky: true
          });
        }
      );
  }
}
